export const formatID = (id: string) => {
  if (typeof id !== "string") return "";

  return id
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s/g, "-");
};
